<template>
  <div class="win">
    <div class="header">
      <div class="navItem">
        <i class="iconfont el-icon-setting"></i>
        <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px' : '' }">告警模板</div>
      </div>
    </div>
    <div class="content" v-loading="loading" element-loading-text="Loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(42, 43, 44, 0.6)">
      <el-form @submit.native.prevent class="table_header tableSearchForm" :inline="true" size="small" label-position="left">
        <div class="btn btn_active" style="margin-right: 10px" @click="add">
          <span>{{ $t("ems.add") }}</span>
        </div>
        <div class="btn btn_active" style="margin-right: 10px" @click="deleteMultiple">
          <span>批量删除</span>
        </div>
        <el-form-item label="设备类型">
          <el-select v-model="form.deviceTypes" placeholder="请选择" style="width: 230px" popper-class="selectDown" multiple collapse-tags>
            <el-option v-for="item in deviceOption" :key="item.type" :label="item.name" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="告警级别">
          <el-select v-model="form.alarmLevel" placeholder="请选择" style="width: 100px" popper-class="selectDown" clearable>
            <el-option value="1" :label="$t('ems.alarm.Level1')"></el-option>
            <el-option value="2" :label="$t('ems.alarm.Level2')"></el-option>
            <el-option value="3" :label="$t('ems.alarm.Level3')"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="告警内容"><el-input v-model="form.alarmName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 150px"></el-input></el-form-item>
        <el-form-item label="告警编号"><el-input v-model="form.alarmNo" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 150px"></el-input></el-form-item>
        <div class="btn btn_active" @click="search">
          <i class="iconfont icon-sousuo"></i><span>{{ $t("ems.history.search") }}</span>
        </div>
        <div class="btn btn_active" @click="reset">
          <i class="iconfont icon-reset"></i><span>{{ $t("ems.alarm.reset") }}</span>
        </div>
        <div class="btn btn_active" @click="handleUpload"><i class="iconfont el-icon-upload"></i><span>导入</span></div>
      </el-form>
      <el-table :data="list" style="width: 100%" v-loading="listLoading" border size="small" @selection-change="handleSelectionChange" :height="700" class="BMSTable">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column label="告警编号" align="center" prop="alarmNo"></el-table-column>
        <el-table-column label="告警内容" show-overflow-tooltip align="center" prop="alarmName"></el-table-column>
        <el-table-column label="告警内容英文" show-overflow-tooltip align="center" prop="alarmNameEn"></el-table-column>
        <el-table-column label="告警级别" align="center">
          <template slot-scope="scope">
            <div>{{ scope.row.alarmLevel | alarmLevelF }}</div>
          </template>
        </el-table-column>
        <el-table-column label="设备类型" align="center" prop="deviceTypeName"></el-table-column>
        <el-table-column label="告警类型" align="center" prop="alarmTypeName"></el-table-column>
        <el-table-column label="告警标签" align="center" prop="alarmTag"></el-table-column>
        <el-table-column label="告警标签英文" align="center" prop="alarmTagEn"></el-table-column>
        <el-table-column label="告警来源" align="center" prop="alarmFrom"></el-table-column>
        <el-table-column :label="$t('ems.operate')" align="center">
          <template slot-scope="scope">
            <el-button @click.native.prevent="handleEdit(scope.row)" type="text" size="small" icon="el-icon-edit-outline">{{ $t("ems.edit") }}</el-button>
            <el-button @click.native.prevent="handleDelete(scope.row.id)" type="text" size="small" icon="el-icon-delete">{{ $t("ems.alarm.delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          class="pagePagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          layout="total, sizes, prev, pager, next,jumper"
          :page-size="size"
          :page-sizes="[10, 20, 100]"
          :current-page.sync="page"
          :total="total"
          popper-class="selectDown"
        ></el-pagination>
        <!--                popper-class-->
      </div>
    </div>
    <div v-if="addVisible">
      <el-dialog :title="addForm.id ? '模板编辑' : '模板新增'" :visible.sync="addVisible" append-to-body width="600px" top="70px" :close-on-click-modal="false" custom-class="dialog-custom-class">
        <el-form
          @submit.native.prevent
          class="table_header tableSearchForm"
          style="width: 100%; margin-left: 60px"
          size="small"
          label-width="120px"
          label-position="left"
          :model="addForm"
          :rules="rules"
          ref="ruleForm"
        >
          <el-form-item label="告警编号" prop="alarmNo"><el-input v-model="addForm.alarmNo" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
          <el-form-item label="告警级别" prop="alarmLevel">
            <el-select v-model="addForm.alarmLevel" placeholder="请选择" style="width: 300px" popper-class="selectDown">
              <el-option :value="1" :label="$t('ems.alarm.Level1')"></el-option>
              <el-option :value="2" :label="$t('ems.alarm.Level2')"></el-option>
              <el-option :value="3" :label="$t('ems.alarm.Level3')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备类型" prop="deviceType">
            <el-select v-model="addForm.deviceType" placeholder="请选择" style="width: 300px" popper-class="selectDown">
              <el-option v-for="item in deviceOption" :key="item.value" :label="item.name" :value="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警内容" prop="alarmName"><el-input v-model="addForm.alarmName" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
          <el-form-item label="告警内容英文"><el-input v-model="addForm.alarmNameEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input></el-form-item>
          <el-form-item label="服务标识" style="position: relative;"><el-input v-model="addForm.identifier" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px;"></el-input>
            <div style="line-height: 20px;width: 360px;color: #0ACFE6; font-size: 12px;margin-top: 10px;">当前设备类型[{{addForm.deviceType}}]以[reader开头服务 {{addForm.identifier}}] 会被告警服务处理，如果其他告警需要转发，请填写服务名称</div>
          </el-form-item>
          <el-form-item label="告警类型" v-if="addForm.deviceType == 'DUI' || addForm.deviceType == 'CU' || addForm.deviceType == 'DCB'">
            <el-select v-model="addForm.alarmType" placeholder="请选择" style="width: 300px" popper-class="selectDown">
              <el-option :value="1" label="通讯告警"></el-option>
              <el-option :value="2" label="电堆告警"></el-option>
              <el-option :value="3" label="电簇告警"></el-option>
              <el-option :value="4" label="单体告警"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="告警标签" v-if="addForm.deviceType == 'DUI' || addForm.deviceType == 'CU' || addForm.deviceType == 'DCB'"
            ><el-input v-model="addForm.alarmTag" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input
          ></el-form-item>
          <el-form-item label="告警标签英文" v-if="addForm.deviceType == 'DUI' || addForm.deviceType == 'CU' || addForm.deviceType == 'DCB'"
            ><el-input v-model="addForm.alarmTagEn" :placeholder="$t('ems.alarm.PleaseEnterContent')" style="width: 300px"></el-input
          ></el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="addVisible = false">{{ $t("ems.strategy.cancel") }}</el-button>
          <el-button size="small" type="primary" @click="subminAdd">{{ $t("ems.strategy.confirm") }}</el-button>
        </div>
      </el-dialog>
    </div>
    <div v-if="uploadVis">
      <el-dialog :title="$t('index.upload')" :visible.sync="uploadVis" append-to-body width="800px" top="100px" :close-on-click-modal="false" custom-class="dialog-custom-class">
        <el-form @submit.native.prevent class="table_header tableSearchForm" size="small" label-width="150px" label-position="left" v-loading="uploadLoading">
          <div class="temp_tips">1.告警内容：不能为空</div>
          <div class="temp_tips">2.告警编码：就是tagNo不能为空</div>
          <div class="temp_tips">3.设备类型：不能为空</div>
          <table class="alarm-tmptab-box">
            <tr>
              <td style="padding-left: 10px">堆=DUI</td>
              <td>族=CU</td>
              <td>电池包(电芯)=DCB</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">PCS=SXBLQ</td>
              <td>电表=DB</td>
              <td>空调=KT</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">DI=DI</td>
              <td>温度计=TEMP</td>
              <td>DO=DO</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">水漫=SJ</td>
              <td>IO=IO</td>
              <td>液冷机=YLJ</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">汇流柜=HLG</td>
              <td>UPS=UPS</td>
              <td>GUARD=虚拟门禁</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">BYQ=变压器</td>
              <td>BYQWENKONG=变压器温度控制器</td>
              <td>GLBWK=隔离变温控器</td>
            </tr>
            <tr>
              <td style="padding-left: 10px">GFNBQ=光伏逆变器</td>
              <td>ems控制器=EMSCTRL</td>
            </tr>
          </table>
          <div class="temp_tips">4.服务标识：如果identifier不是readerr开头，需要标注</div>
          <div class="temp_tips">5.告警标签: 堆簇告警需要填写，例如XXXX一级告警，XXXX二级告警，XXXX三级告警，可设XXXX做为标签如果为空，系统会按上述规则截取</div>
          <div class="temp_tips">6.告警类型：堆簇告警需要填写 1-通讯告警 2-电堆告警 3-电簇告警 4-单体告警</div>
          <div class="temp_tips">7.告警来源：为空就是当前设备，如果想显示当前设备具体位置，填写，比如BCU BAU之类得</div>
          <div class="temp_tips">8.告警内容英文</div>
          <div class="temp_tips">9.告警标签英文</div>
          <el-form-item :label="$t('systemSetting.TemplateDownload')">
            <el-button type="primary" @click="handleTemplate">{{ $t("systemSetting.clickDownLoad") }}<i class="el-icon-download el-icon--right"></i></el-button>
          </el-form-item>
          <el-form-item label="上传" style="margin-right: 100px">
            <el-upload
              ref="upload"
              class="avatar-uploader-login"
              action="/api/blade-wems/alarmtemplate/import"
              :multiple="false"
              :show-file-list="true"
              :headers="headers"
              :auto-upload="false"
              :limit="1"
              :on-exceed="handleExceed"
              :on-success="uploadSuccess"
              :on-change="handleChange"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
            >
              <i class="el-icon-upload avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip"></div>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="uploadVis = false">{{ $t("ems.strategy.cancel") }}</el-button>
          <el-button size="small" type="primary" @click="submitUpload">{{ $t("ems.strategy.confirm") }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAlarmtemplatePage, alarmtemplateUpdate, deleteAlarmtemplate, getAlarmtemplateIdentifierList } from "@/api/alarm";
import { getDeviceType } from "@/api/spms";
import spmsweb from "@/config/spmsweb";
import { getStore } from "@/utils/store";
import { Base64 } from "js-base64/base64";
import i18n from "@/lang";
export default {
  name: "alarmTemplateManage",
  data() {
    return {
      opacity: 0,
      loading: false,
      form: {
        alarmLevel: "",
        alarmName: "",
        alarmNo: "",
        deviceTypes: [],
      },
      deviceOption: [],
      listLoading: false,
      size: 10,
      page: 1,
      list: [],
      total: 0,
      addVisible: false,
      addForm: {},
      rules: {
        alarmNo: { required: true, message: "请填写内容", trigger: "blur" },
        alarmName: { required: true, message: "请填写内容", trigger: "blur" },
        alarmLevel: { required: true, message: "请填写内容", trigger: "blur" },
        deviceType: { required: true, message: "请选择", trigger: "change" },
      },
      multipleSelection: [],
      uploadVis: false,
      uploadLoading: false,
      headers: {},
      fileList: [],
      accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
    };
  },
  computed: {
    ...mapGetters(["language"]),
  },
  filters: {
    nullFormat(val) {
      if (val === null || val === undefined) {
        return "--";
      } else {
        return val;
      }
    },
    alarmLevelF(val) {
      switch (val) {
        case 1:
          return i18n.t("ems.alarm.Level1");
        case 2:
          return i18n.t("ems.alarm.Level2");
        case 3:
          return i18n.t("ems.alarm.Level3");
        default:
          return "";
      }
    },
  },
  created() {
    this.headers = {
      Authorization: `Basic ${Base64.encode(`${spmsweb.clientId}:${spmsweb.clientSecret}`)}`,
      "Blade-Auth": "bearer " + getStore({ name: "access_token" }),
      // 'Content-Type': 'application/json'
    };
  },
  mounted() {
    this.initOption();
    setTimeout(() => {
      this.opacity = 1;
    }, 200);
    this.loadData();
  },
  methods: {
    initOption() {
      getDeviceType().then((res) => {
        if (res && res.data && res.data.data) {
          this.deviceOption = res.data.data;
        }
      });
    },
    handleTemplate() {
      window.open("/AlarmTemp20230830.xlsx", "_blank");
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleUpload() {
      this.uploadVis = true;
    },
    search() {
      this.loadData();
    },
    loadData() {
      this.listLoading = true;
      const params = { ...this.form };
      params.current = this.page;
      params.size = this.size;
      params.deviceTypes = params.deviceTypes.join(",");
      getAlarmtemplatePage(params)
        .then((res) => {
          this.listLoading = false;
          this.list = res.data.data.records;
          this.total = res.data.data.total;
          console.log(this.list);
        })
        .catch((err) => {
          this.listLoading = false;
          console.log(err);
        });
    },
    handleSizeChange(val) {
      this.page = 1;
      this.size = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.loadData();
    },
    reset() {
      this.page = 1;
      this.form = {
        alarmLevel: "",
        alarmName: "",
        alarmNo: "",
        deviceTypes: [],
      };
      this.loadData();
    },
    add() {
      this.addForm = {};
      this.addVisible = true;
    },
    deleteMultiple() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请选择模板！");
        return false;
      }
      this.$confirm("确认删除所选模板?", {
        confirmButtonText: i18n.t("ems.strategy.confirm"),
        cancelButtonText: i18n.t("ems.strategy.cancel"),
        type: "warning",
      })
        .then(() => {
          let ids = this.multipleSelection.map((i) => i.id).join(",");
          deleteAlarmtemplate(ids)
            .then(() => {
              this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
              this.loadData();
            })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .then(() => {});
    },
    subminAdd() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.addVisible = false;
          const params = { ...this.addForm };
          alarmtemplateUpdate(params)
            .then(() => {
              this.$message.success(i18n.t("ems.strategy.AddedSuccessfully"));
              this.loadData();
            })
            .catch((err) => {
              console.log(err);
              this.$message.error(i18n.t("ems.addFailedTip") + err);
            });
        } else {
          return false;
        }
      });
    },
    handleEdit(row) {
      getAlarmtemplateIdentifierList({ deviceType: row.deviceType }).then((res) => {
        this.addVisible = true;
        this.addForm = JSON.parse(JSON.stringify(row));
        this.addForm.identifier = res.data.data || "";
      });
    },
    handleDelete(id) {
      this.$confirm("确认删除该模板?", {
        confirmButtonText: i18n.t("ems.strategy.confirm"),
        cancelButtonText: i18n.t("ems.strategy.cancel"),
        type: "warning",
      })
        .then(() => {
          deleteAlarmtemplate(id)
            .then(() => {
              this.$message.success(i18n.t("ems.strategy.DeletedSuccessfully"));
              this.loadData();
            })
            .catch((err) => {
              this.$message.error(err);
            });
        })
        .then(() => {});
    },
    submitUpload() {
      if (this.fileList.length === 0) {
        this.$message.error("请选择文件！");
        return;
      }
      this.$refs.upload.submit();
    },
    beforeAvatarUpload(file) {
      console.log(file);
      const isJPG = file.type.includes("sheet");
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error("上传文件只能是 xls，wps 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 10MB!");
      }
      return isJPG && isLt2M;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    handleError(res) {
      console.log(JSON.stringify(res));
      this.$message.error(res.msg);
    },
    uploadSuccess(res) {
      if (res.success) {
        this.$message({
          type: "success",
          message: "操作成功！",
        });
        this.uploadVis = false;
        this.search();
      } else {
        this.$refs.upload.clearFiles();
        this.$message.error("上传文件失败！" + res.msg);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../styles/site";

.alarm-tmptab-box {
  width: 100%;
  tr,
  td {
    color: $font_bright_blue_title;
  }
}
.temp_tips {
  color: $font_bright_blue_title;
}
.win {
  width: 100%;
  height: 100%;
  .header {
    height: 52px;
    background-color: var(--nav_inner);
    position: relative;
    .navItem {
      height: 100%;
      color: $font_bright_blue_title;
      display: flex;
      align-items: center;
      transition: all 0.3s linear;
      i {
        font-size: 22px;
        margin: 3px 20px 0;
      }
      .title {
        letter-spacing: 3px;
        font-size: 22px;
      }
      .desc {
        margin-left: 24px;
        font-size: 16px;
        color: $_128_128_128;
      }
    }
    .navRight {
      position: absolute;
      height: 100%;
      right: 0;
      top: 0;
      display: flex;
      align-items: center;
      .creatTime {
        font-size: 18px;
        color: $_191_191_191;
        margin-right: 40px;
        span {
          padding-left: 20px;
          color: $font_bright_blue_title;
        }
      }
      .btn {
        height: 30px;
        width: 85px;
        border: $font_bright_blue_title solid 2px;
        margin-right: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: $font_bright_blue_title;
        cursor: pointer;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        i {
          margin-right: 5px;
          font-size: 18px;
        }
      }
    }
  }
  .content {
    padding: 0 20px;
    overflow: hidden;

    .table_header {
      margin-top: 20px;
      height: 30px;
      margin-bottom: 20px;
    }
    .page {
      margin-top: 20px;
      height: 30px;
    }
    .strategy_main {
      height: 780px;
    }
  }
}
</style>
